import { FormInstance } from "antd";
import { useDownloadReport } from "../../../../../lib/hooks/useDownloadReport";
import { useOpenProgressModal } from "../../../../../lib/hooks/useOpenProgressModal";
import ReportService from "../../../../../services/reportGeneration";
import { useCallback } from "react";
import { useGetDefaultRequest } from "../useGetDefaultRequest";
import { SUCCESS_PDF_DOWNLOAD } from "../../../../../lib/constants";

export const useDisbursementsReport = (
  form: FormInstance,
  setIsDownloading: React.Dispatch<React.SetStateAction<boolean>>,
  onCancelClick: () => void,
) => {
  const { download } = useDownloadReport(setIsDownloading);

  const { openModal } = useOpenProgressModal(
    "Generating Disbursements Report",
    "Generating Disbursements Report failed",
    (id?: string) => download(ReportService, id),
    {
      customMsg: SUCCESS_PDF_DOWNLOAD,
    },
  );

  const { getRequest } = useGetDefaultRequest();

  const printDisbursementsReport = useCallback(async () => {
    try {
      const res = await form.validateFields();

      setIsDownloading(true);

      const request: any = getRequest(res);

      const id: string = await ReportService.generateReportByName(
        "DisbursementReport",
        request,
      );

      openModal(id);

      onCancelClick();
    } catch {
      setIsDownloading(false);
    }
  }, [form, getRequest, onCancelClick, openModal, setIsDownloading]);

  return { printDisbursementsReport };
};
